import { usePrefetchDossierActiesQuery } from "@/entities/actie";
import { usePrefetchBerichtenByIdQuery } from "@/entities/bericht";
import { usePrefetchDossierBetrokkenStationsQuery } from "@/entities/betrokken-stations";
import { usePrefetchDossierSettingsQuery } from "@/entities/dossier-settings";
import { usePrefetchDossierDossierLogboekQuery } from "@/entities/logboek";
import { usePrefetchDossierSuggestiesQuery } from "@/entities/suggestie";
import { useAuth, UserRole } from "@/features/auth";

export function usePrefetchDossier(dossierId: string) {
    const { hasRole } = useAuth();
    const isRCB = hasRole(UserRole.DEWIT) || hasRole(UserRole.TRANSVISION);
    const isKlantenservice = hasRole(UserRole.KLANTENSERVICE);
    const isAlleenLezen = hasRole(UserRole.ALLEENLEZEN);
    const isSupportConsultant = hasRole(UserRole.SUPPORTCONSULTANT);
    const cannotFetchBerichten = isRCB || isKlantenservice;
    const cannotFetchActies = isAlleenLezen || isSupportConsultant;
    const cannotFetchSuggesties = isRCB || isKlantenservice || isAlleenLezen || isSupportConsultant;

    // Prefetch a subset of dossier queries to improve initial load performance.
    const prefetchDossierSettings = usePrefetchDossierSettingsQuery(dossierId);
    const prefetchBetrokkenStations = usePrefetchDossierBetrokkenStationsQuery(dossierId);
    const prefetchLogboek = usePrefetchDossierDossierLogboekQuery(dossierId);
    const prefetchBerichten = usePrefetchBerichtenByIdQuery(dossierId);
    const prefetchActies = usePrefetchDossierActiesQuery(dossierId);
    const prefetchSuggesties = usePrefetchDossierSuggestiesQuery(dossierId);

    return () => {
        void prefetchDossierSettings();
        void prefetchBetrokkenStations();
        void prefetchLogboek();
        if (!cannotFetchActies) void prefetchActies();
        if (!cannotFetchBerichten) void prefetchBerichten();
        if (!cannotFetchSuggesties) void prefetchSuggesties();
    };
}
